import { getBrandPlaceData, getChannel, getContent, getDocument, getPlaceId } from '@lib/server';
import { type Event, Place } from '@types';

export const getEvent = async (domain: string, venue: string | null, eventSlug: string) => {
  const channel = await getChannel(decodeURIComponent(domain));

  if (!channel) return {};

  const { placeId } = venue ? await getPlaceId(channel, decodeURIComponent(venue)) : {};

  const event = await getContent<Event>('event')
    .setWhere([
      ['fields.slug', 'eq', eventSlug],
      placeId
        ? ['sys.referencedBy', 'contains', placeId]
        : ['sys.referencedBy', 'containsany', channel.places.map((place) => place.id)],
    ])
    .setTags([channel?.channelId])
    .setDepth(0)
    .fetch([
      'fields.slug',
      'fields.eventName',
      'fields.shortDescription',
      'fields.dates',
      'fields.pageContent',
      'sys.referencedBy',
      'fields.seo',
      'id',
      'fields.image',
    ])
    .then((res) => res?.find((event) => channel.places.some((place) => event.sys.referencedBy.includes(place.id))));

  if (!event) return {};

  const place = placeId
    ? await getDocument<Place>('place', placeId, {
        select: ['fields.name', 'fields.apps', 'fields.default.address'],
        tags: [channel?.channelId],
        depth: 0,
        // combine the name and apps with the location reference, including additionalFields and ID
      }).then((res) => ({ id: res.id, ...res.fields }))
    : await getBrandPlaceData(decodeURIComponent(domain)).then((res) =>
        res?.places.find((place) => event?.sys.referencedBy.includes(place.id)),
      );

  return { event: { id: event?.id, ...event?.fields }, place, channel };
};
